import React from "react";
import ReactDOM from "react-dom/client";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "bootstrap/dist/js/bootstrap.js";

import "tailwindcss/tailwind.css";
import "tw-animate-css";

import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { Provider } from "react-redux";
import store from "./store/index";
import axios from "axios";
import config from "constants/config";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { ToastContainer } from "react-toastify";
import { NuqsAdapter } from "nuqs/adapters/react-router/v6";
import SocketContextProvider from "providers/socket.provider";
import { TourProvider } from "@reactour/tour";
import { tourSteps } from "./constants/global";
import FinanceTourContentComponent from "./component/finance/FinanceTourContentComponent";
import "./typography.css";

const queryClient = new QueryClient();

axios.defaults.baseURL = config.API_URL;

require("./store/subscriber");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <NuqsAdapter>
            <QueryClientProvider client={queryClient}>
                <TourProvider
                    ContentComponent={FinanceTourContentComponent}
                    steps={tourSteps}
                    styles={{
                        popover: (base) => ({
                            ...base,
                            borderRadius: 10,
                            padding: 1,
                            backgroundColor: "transparent",
                        }),
                        maskArea: (base) => ({ ...base, rx: 10 }),
                        padding: {
                            mask: 0,
                            // popover: [0, 2],
                            wrapper: 1,
                        },
                    }}
                    onClickHighlighted={(e) => {
                        e.stopPropagation();
                    }}
                    disableInteraction
                >
                    <Provider store={store}>
                        <SocketContextProvider>
                            <BrowserRouter>
                                <App />
                                <ToastContainer
                                    position="top-right"
                                    closeButton={true}
                                    stacked={true}
                                    newestOnTop={true}
                                    limit={5}
                                />
                            </BrowserRouter>
                        </SocketContextProvider>
                    </Provider>
                </TourProvider>
            </QueryClientProvider>
        </NuqsAdapter>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
